import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik";
import { Form, Col } from "react-bootstrap";
import React, { useState } from "react";
import { store } from "../../../App";
import styled from "styled-components";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { generatePDF, GetDetails, ModuleHeader } from "../../utils/commonFunctions";
const DistrictwiseDesignationCount = () => {
  const TableWrapper = styled.div`
    width: 130%;
  `;
  const [rowSums, setRowSums] = useState([]);
  const [EmpTypeList, setEmpTypeList] = useState();
  const [tableData, setTableData] = useState([]);
  const [tableDataenable, setTableDataenable] = useState(false);
  React.useEffect(() => {
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          );
        });
        setEmpTypeList(options);
      }
    });
  }, []);
  const formik = useFormik({
    initialValues: {
      emp_type: "All"
    },
    onSubmit: (values) => {
      console.log("Selected Employee Type:", values.emp_type);

      store.dispatch({ type: "SHOW_SPINNER" });

      HousingService.DistrictwiseDesignationCount(values).then((res) => {
        console.log("Response:", res.data);

        // Extract column names
        const columnNames = Object.keys(res.data[0]);

        // Filter out columns where every value is 0
        const filteredColumns = columnNames.filter((columnName) => {
          return res.data.every((item) => item[columnName] === 0);
        });

        // Filter data based on the remaining columns
        const filteredData = res.data.map((item) => {
          const filteredItem = {};
          columnNames.forEach((columnName) => {
            // Only include columns that are not in filteredColumns
            if (!filteredColumns.includes(columnName)) {
              filteredItem[columnName] = item[columnName];
            }
          });
          return filteredItem;
        });

        //  setfilteredColumnCount(columnNames.length - filteredColumns.length);

        console.log("filteredData..", filteredData);
        //  setDetailedPayParticulars(filteredData);
        setTableData(res.data);
        setTableDataenable(true);
        store.dispatch({ type: "HIDE_SPINNER" });
      });
    }
  });

  React.useEffect(() => {
    const calculateRowSums = () => {
      const sums = tableData.map((item) =>
        Object.values(item)
          .filter(
            (value, index) =>
              index > 1 &&
              !["designation_name"].includes(Object.keys(item)[index])
          )
          .reduce((acc, val) => acc + (parseFloat(val) || 0), 0)
      );
      setRowSums(sums);
    };

    calculateRowSums();
  }, [tableData]);
  return (
    <>
      {" "}
      <NavigationServicesHeader />
      <ModuleHeader title=" Designation-wise & district-wise Employee count" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }} >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="" ></Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="">
                <th>Employee Type:</th>
                <Field name="emp_type" className={ formik.touched.emp_type && formik.errors.emp_type ? "form-control is-invalid" : "form-control" } onChange={(e) => { formik.handleChange(e); }} component="select" >
                  <option value="All">All</option>
                  {EmpTypeList}
                </Field>
                {formik.touched.emp_type && formik.errors.emp_type ? ( <div className="invalid-feedback"> {formik.errors.emp_type} </div> ) : null}
              </Col>
              <GetDetails/>
            </OFMSUI.Row>
          </Form>
        </FormikProvider>
        {tableDataenable && (
          <div style={{ overflow: "auto" }}>
            <TableWrapper>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  style={{ float: "right", color: "#fff", fontSize: "12px" }}
                >
                  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="my-table"
                    filename="DistrictwiseDesignationCount"
                    sheet="tablexls"
                    buttonText="Excel"
                  ></ReactHTMLTableToExcel>
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => generatePDF("my-table", "Designation-wise & district-wise employee count", "DistrictwiseDesignationCount.pdf", 10)} 
                  style={{
                    float: "right",
                    fontSize: "12px"
                  }}
                >
                  PDF
                  <MdOutlinePictureAsPdf />
                </button>
              </OFMSUI.Col>
              <OFMSUI.Table striped bordered hover id="my-table">
                {tableData.length > 0 && (
                  <thead>
                    <tr className="table_countshead">
                      <th>S.No</th>
                      <th>DesignationName</th>
                      <th>HeadOffice</th>
                      {Object.keys(tableData[0])
                        .filter(
                          (key) =>
                            !["designation_name", "head_office"].includes(key)
                        )
                        .map((key) => (
                          <th key={key}>
                            {
                              key
                                .replace(/_/g, " ") // Replace underscores with spaces
                                .replace(/\b\w/g, (match) =>
                                  match.toUpperCase()
                                ) // Capitalize the first letter of each word
                                .replace(/\s+/g, "") // Remove spaces
                            }
                          </th>
                        ))}
                      <th>Total</th>
                    </tr>
                  </thead>
                )}
                <tbody>
                  {tableData.length === 0 ? (
                    <tr>
                      <td colSpan="number_of_columns">No data found</td>
                    </tr>
                  ) : (
                    tableData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.designation_name}</td>
                          <td>{item.head_office}</td>
                          {Object.keys(item)
                            .filter(
                              (key) =>
                                !["designation_name", "head_office"].includes(
                                  key
                                )
                            )
                            .map((key, colIndex) => (
                              <td key={key} style={{ textAlign: "right" }}>
                                {item[key]}
                              </td>
                            ))}
                          <td style={{ textAlign: "right" }}>
                            {rowSums[index]}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
                <tfoot>
                  <tr className="table_countshead">
                    <td colSpan="2">Total</td>
                    <td>
                      {tableData.reduce(
                        (total, item) =>
                          total + (parseFloat(item.head_office) || 0),
                        0
                      )}
                    </td>
                    {Object.keys(tableData[0])
                      .filter(
                        (key) =>
                          !["designation_name", "head_office"].includes(key)
                      )
                      .map((key) => (
                        <td key={key} style={{ textAlign: "right" }}>
                          {tableData.reduce(
                            (sum, item) => sum + (parseFloat(item[key]) || 0),
                            0
                          )}
                        </td>
                      ))}
                    <td style={{ textAlign: "right" }}></td>
                  </tr>
                </tfoot>
              </OFMSUI.Table>
            </TableWrapper>
          </div>
        )}
      </OFMSUI.Container>
    </>
  );
};

export default DistrictwiseDesignationCount;
